export default __webpack_public_path__ + "static/west_ed_laurel-567f5a3022ab0ef75604026a068209ce.svg";